import { Button } from '@fluentui/react-components';
import { DeleteRegular } from '@fluentui/react-icons';
import { TableActionButtons } from './TableActionButtons';

type TProps = {
  label: string;
  onArchive: () => void;
};

const ArchiveTableAction = ({ label, onArchive }: TProps) => (
  <TableActionButtons>
    <Button icon={<DeleteRegular />} appearance="transparent" aria-label={label} onClick={onArchive} />
  </TableActionButtons>
);

export default ArchiveTableAction;
